import { render } from "./LayoutPaymentStatus.vue?vue&type=template&id=751a6ba6&scoped=true&ts=true"
import script from "./LayoutPaymentStatus.vue?vue&type=script&lang=ts"
export * from "./LayoutPaymentStatus.vue?vue&type=script&lang=ts"

import "./LayoutPaymentStatus.vue?vue&type=style&index=0&id=751a6ba6&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751a6ba6"]])

export default __exports__